import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const LOGO = "https://public.readdy.ai/ai/img_res/f49e481e-6249-471e-b877-3a3cae2fc3b1.png";

const navLinks = [
  { label: "ホーム", path: "/" },
  { label: "ギャラリー", path: "/gallery" },
  { label: "サロンについて", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-white border-b border-[#E8E0D8]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3">
          <img src={LOGO} alt="BE:NAIL" className="h-10 w-auto object-contain" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap font-medium ${
                location.pathname === link.path
                  ? "text-[#B8956A]"
                  : scrolled
                  ? "text-[#3D2E2A] hover:text-[#B8956A]"
                  : "text-white hover:text-[#C9A86A]"
              }`}
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Booking Button */}
        <div className="flex items-center gap-4">
          <Link
            to="/booking"
            className="hidden md:inline-flex items-center gap-2 bg-[#B8956A] text-white px-6 py-2.5 rounded-full text-sm font-medium tracking-wider hover:bg-[#A07B55] transition-colors whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-calendar-line text-sm"></i>
            </span>
            ご予約
          </Link>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
              scrolled ? "text-[#3D2E2A]" : "text-white"
            }`}
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#E8E0D8] px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-base tracking-wider cursor-pointer ${
                location.pathname === link.path ? "text-[#B8956A]" : "text-[#3D2E2A]"
              }`}
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/booking"
            className="inline-flex items-center justify-center gap-2 bg-[#B8956A] text-white px-6 py-3 rounded-full text-sm font-medium tracking-wider cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-calendar-line text-sm"></i>
            </span>
            ご予約はこちら
          </Link>
        </div>
      )}
    </header>
  );
}
